<template>
  <v-container>
    <v-row>
      <v-col sm="12" md="8">
        <v-row>
          <v-col sm="12">
            <h2 class="text-h2">Váš košík</h2>
          </v-col>
        </v-row>

        <template v-if="loading">
          <v-row>
            <v-col sm="12">
              <v-skeleton-loader
                class="mx-auto"
                type="card"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </template>

        <template v-if="!loading">
          <v-row v-if="orderr == null">
            <v-col sm="12">
              <v-alert
                border="bottom"
                colored-border
                type="warning"
                elevation="2"
                class="my-5"
              >
                Košík je prázdný. Nenašli jsme žádnou rozpracovanou rezervaci.
              </v-alert>
            </v-col>
          </v-row>

          <v-row v-if="orderr == null">
            <v-col sm="12" md="8">
              <v-btn @click="goToHome" color="primary">
                Vytvořit novou rezervaci
              </v-btn>
            </v-col>
          </v-row>

          <template v-if="orderr != null">
            <v-row>
              <v-col sm="12">
                <v-row>
                  <v-col sm="12">
                    <v-list
                      v-if="orderr.orderrItemGroups.items.length > 0"
                      three-line
                    >
                      <template v-if="orderrItemGroupsRent.length > 0">
                        <v-subheader>{{ mobConfig.rentHeader }}</v-subheader>
                        <v-divider></v-divider>

                        <cart-item-rent
                          v-for="oig in this.orderrItemGroupsRent"
                          v-bind:key="oig.id"
                          v-bind:orderr-item-group="oig"
                        >
                        </cart-item-rent>
                      </template>

                      <v-divider></v-divider>

                      <template v-if="orderrItemGroupsCourse.length > 0">
                        <v-subheader>{{ mobConfig.schoolHeader }}</v-subheader>
                        <v-divider></v-divider>

                        <cart-item-course
                          v-for="oig in this.orderrItemGroupsCourse"
                          v-bind:key="oig.id"
                          v-bind:orderr-item-group="oig"
                        >
                        </cart-item-course>
                      </template>
                    </v-list>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col sm="12">
                    <v-alert
                      v-if="orderr.orderrItemGroups.items.length == 0"
                      border="bottom"
                      colored-border
                      type="warning"
                      elevation="2"
                      class="my-5"
                    >
                      Košík je prázdný.
                    </v-alert>
                  </v-col>
                </v-row>

                <v-row v-if="mobConfig.cartStaticInfo">
                  <v-col sm="12">
                    <v-alert
                      border="top"
                      outlined
                      type="info"
                      elevation="1"
                      class="my-5"
                      v-html="mobConfig.cartStaticInfo"
                    ></v-alert>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col sm="12" md="8">
                    <v-btn @click="goToHome"> Rezervovat další věc </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </template>
      </v-col>

      <v-col sm="12" md="4">
        <v-card v-if="!loading && orderr != null">
          <v-card-title> Přehled objednávky </v-card-title>

          <v-card-text>
            <orderr-summary
              v-bind:orderr="orderr"
              showExpirationTime
              showStatus
              showRentalPeriod
              showPrice
            ></orderr-summary>
          </v-card-text>

          <v-card-actions class="pt-0">
            <v-btn
              @click="goToCheckout()"
              :loading="submiting"
              :disabled="currentOrderrExpired"
              block
              color="primary accent-4"
            >
              Pokračovat
            </v-btn>
          </v-card-actions>
        </v-card></v-col
      >
    </v-row>
  </v-container>
</template>

<script>
import CartItemRent from "@/components/CartItemRent";
import CartItemCourse from "@/components/CartItemCourse";
import OrderrSummary from "@/components/OrderrSummary";

export default {
  components: {
    CartItemRent,
    CartItemCourse,
    OrderrSummary,
  },

  metaInfo: {
    title: "Košík",
  },

  data() {
    return {
      loading: false,
      submiting: false,
    };
  },

  async mounted() {
    console.log("mounted");

    // nastavit stav, ze se nacita
    this.loading = true;

    // zkontrolovat, ze je uzivatel prihlaseny a dalsi nutne prerekvizity
    if (
      this.$store.state.user == null ||
      this.$store.state.appInstance == null
    ) {
      console.log("Nesplnene prerekvizity user nebo app instance jsou null");

      this.goToHome();
    }

    // nacist aktualni objednavku s polozkami
    await this.$store.dispatch("loadCurrentOrderrDRAFT");

    // dokoncit nacitani - zmena stavu
    this.loading = false;
  },

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },

    orderr() {
      return this.$store.state.currentOrderr;
    },

    currentOrderrExpired() {
      return this.$store.state.currentOrderrExpired;
    },

    orderrItemGroupsRent() {
      return this.orderr.orderrItemGroups.items.filter((item) => {
        console.log(item);
        return item.product.productType == "RENTAL";
      });
    },

    orderrItemGroupsCourse() {
      return this.orderr.orderrItemGroups.items.filter(
        (item) => item.product.productType == "SCHOOL"
      );
    },
  },

  methods: {
    goToHome() {
      this.$router.push({ name: "home" });
    },

    goToCheckout() {
      this.$router.push({ name: "checkout-pickup" });
    },
  },
};
</script>
